
<div class="authz-access-hint-footer" *ngIf="authzAccessHint?.message">
  <div class="hint-content">
    <div class="hint-icon">
      <i class="fas fa-info-circle"></i>
    </div>

    <div class="hint-text">
      <span class="hint-message">
        {{ authzAccessHint.message }}
      </span>

      <a
        *ngIf="authzAccessHint.requestUrl"
        [href]="authzAccessHint.requestUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="hint-link"
      >
        <i class="fas fa-globe"></i>
        <span>Request Access in Guardian</span>
        <i class="fas fa-arrow-up-right-from-square external-icon"></i>
      </a>
    </div>
  </div>
</div>
